export const columnsPrincipalsList = [
  {
    title: "Nom",
    dataIndex: "name",
    key: "name",
    render: (n, record) => n,
    width: "15%",
    sorter: (a, b) => {
      return a.name.localeCompare(b.name);
    },
  },
  {
    title: "Adresse",
    dataIndex: "address",
    width: "15%",
    key: "address",
  },
];

export const inputsPrincipalsList = [
  {
    parentLabel: null,
    children: [
      {
        label: "Filtre par interprtes",
        name: "id",
        value: "",
        type: "input",
        capitalize: false,
        col: 6,
      },
      {
        label: "Filtre par date",
        name: "name",
        value: "",
        type: "input",
        capitalize: false,
        col: 6,
      },
      {
        label: "Filtre par numero de commande",
        name: "type",
        value: "all",
        type: "select",
        selectContent: [
          { label: "Tous", value: "all" },
          { label: "Location", value: "renting" },
          { label: "Vente", value: "selling" },
        ],
        col: 6,
      },
      {
        label: "Filtre par etat de commande",
        name: "status",
        value: "all",
        type: "select",
        selectContent: [
          {
            label: "Tous",
            value: "all",
          },
        ],
        col: 6,
      },
    ],
  },
];
